{
  "iframeWaitingMessage": "Vielen Dank für Ihre Geduld. Nur noch ein kurzer Moment...",
  "otherOrganizations": "Andere Unternehmen",
  "solutionIframe": "Hauptinhalt",
  "unloadPromptMessage": "Sind Sie sicher?"
}
